import { NgClass, TitleCasePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { StrategyDspAudienceType } from "@front/m19-api-client";
import { AudienceId, AudiencesService } from "@front/m19-services";
import { IBadgeComponent } from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { DspAudienceLineComponent } from "../dsp-audience-line/dsp-audience-line.component";
import { toObservable, toSignal } from "@angular/core/rxjs-interop";
import { switchMap } from "rxjs";

@Component({
  selector: "app-dsp-audience-list",
  templateUrl: "./dsp-audience-list.component.html",
  imports: [IBadgeComponent, TranslocoDirective, TitleCasePipe, DspAudienceLineComponent, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DspAudienceListComponent {
  private readonly audiencesService = inject(AudiencesService);

  readonly DspStrategyDspAudienceType = StrategyDspAudienceType;

  readonly audiences = input.required<AudienceId[][]>();
  readonly audienceType = input.required<StrategyDspAudienceType>();

  audiences$ = toObservable(this.audiences);

  readonly emptyDspAudiences = computed(
    () => this.audiences().length === 0 || this.audiences().every((group) => group.length === 0),
  );

  readonly dspAudiences = toSignal(
    this.audiences$.pipe(switchMap((audiences) => this.audiencesService.getAudiencesFromIds(audiences))),
  );
}
